module.exports = __webpack_public_path__ + "static/media/caret-square-right.e163f94f.svg";